var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "raiseIssueModal",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "modal-class": "planswitchhistory-modal"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('div', {
    staticClass: "planswitchhistory_modal--card"
  }, [_c('div', {
    staticClass: "modal-header-wrapper"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.186 2.753v3.596c0 .487.195.955.54 1.3a1.85 1.85 0 0 0 1.306.539h4.125"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.25 8.568v8.568a4.25 4.25 0 0 1-1.362 2.97a4.28 4.28 0 0 1-3.072 1.14h-7.59a4.3 4.3 0 0 1-3.1-1.124a4.26 4.26 0 0 1-1.376-2.986V6.862a4.25 4.25 0 0 1 1.362-2.97a4.28 4.28 0 0 1 3.072-1.14h5.714a3.5 3.5 0 0 1 2.361.905l2.96 2.722a2.97 2.97 0 0 1 1.031 2.189M7.647 7.647h3.265M7.647 12h8.706m-8.706 4.353h8.706"
    }
  })])])]), _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "title-wrap"
  }, [_vm._v(" Plan Switch ")]), _c('div', {
    staticClass: "content-date"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.row.created_at)) + " ")])])]), _c('div', {
    staticClass: "plan-switch-wrapper"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "old-plan plan-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" From ")]), _c('div', {
    staticClass: "plan-name"
  }, [_vm._v(" " + _vm._s(_vm.row.old_plan_name) + " ")])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "arrow-icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 640 640"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M439.1 297.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L371.2 320L233.9 182.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    }
  })])])]), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "new-plan plan-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" To ")]), _c('div', {
    staticClass: "plan-name"
  }, [_vm._v(" " + _vm._s(_vm.row.new_plan_name) + " ")])])])])]), _c('ul', {
    staticClass: "planswitch-contentlistwrapper"
  }, [_c('li', [_c('div', {
    staticClass: "left-content"
  }, [_vm._v("System ID")]), _c('div', {
    staticClass: "right-content"
  }, [_vm._v(_vm._s(_vm.row.policy_id))])]), _c('li', [_c('div', {
    staticClass: "left-content"
  }, [_vm._v("Member Name")]), _c('div', {
    staticClass: "right-content"
  }, [_vm._v(_vm._s(_vm.row.member_name))])]), _c('li', [_c('div', {
    staticClass: "left-content"
  }, [_vm._v("Requested From")]), _c('div', {
    staticClass: "right-content"
  }, [_vm._v(_vm._s(_vm.row.origin))])]), _c('li', [_c('div', {
    staticClass: "left-content"
  }, [_vm._v("Performed by")]), _c('div', {
    staticClass: "right-content"
  }, [_vm._v(_vm._s(_vm.row.requested_by))])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }